// frontend/src/pages/adolescentes/AdolescenteDetailPage.jsx
import { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import LoadingSpinner from '../../components/common/LoadingSpinner';

function Row({ label, children }) {
  return (
    <div className="row mb-2">
      <div className="col-12 col-md-3 text-secondary">{label}</div>
      <div className="col-12 col-md-9 text-light">{children}</div>
    </div>
  );
}

function AdolescenteDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [adolescente, setAdolescente] = useState(null);
  const [movimentacoes, setMovimentacoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fmtDate = (yyyy_mm_dd) => {
    if (!yyyy_mm_dd) return '—';
    const parts = String(yyyy_mm_dd).split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return yyyy_mm_dd;
  };

  // Situação atual por MOVIMENTAÇÃO (permanece)
  const getSituacaoAtual = (mov) => {
    const arr = mov?.situacoes || [];
    if (Array.isArray(arr) && arr.length > 0) {
      const last = arr[arr.length - 1];
      return last?.nome || '—';
    }
    return '—';
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [adolescenteResponse, movimentacoesResponse] = await Promise.all([
          api.get(`/adolescentes/${id}`),
          api.get(`/adolescentes/${id}/movimentacoes`),
        ]);

        setAdolescente(adolescenteResponse.data.data);
        setMovimentacoes(movimentacoesResponse.data.data || []);
      } catch (err) {
        console.error("Falha ao carregar dados do adolescente:", err);
        setError('Não foi possível carregar as informações do adolescente.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return <LoadingSpinner text="Carregando dados do adolescente..." />;
  }

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  if (!adolescente) {
    return <div className="alert alert-warning">Adolescente não encontrado.</div>;
  }

  return (
    <>
      {/* Cabeçalho */}
      <div className="content-header d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div>
          <h1 className="content-title">Adolescente</h1>
          <p className="content-subtitle mb-0">
            Dados cadastrais e histórico de movimentações de <strong>{adolescente.nome_adolescente}</strong>
          </p>
        </div>
        <div className="d-flex gap-2">
          <button className="btn btn-outline-secondary" onClick={() => navigate('/painel/adolescentes')}>
            <i className="bi bi-arrow-left me-2" /> Voltar à Lista
          </button>
          <Link to={`/painel/adolescentes/${id}/movimentacoes/novo`} className="btn btn-primary">
            <i className="bi bi-plus-lg me-2" /> Iniciar Movimentação
          </Link>
        </div>
      </div>

      {/* Card: Dados Cadastrais */}
      <div className="card mb-4">
        <div className="card-header d-flex justify-content-between align-items-center text-light">
          <h5 className="mb-0">Dados Cadastrais</h5>
          <button className="btn btn-sm btn-outline-warning" disabled>
            <i className="bi bi-pencil-square me-2" /> Editar Cadastro (em breve)
          </button>
        </div>
        <div className="card-body text-light">
          <Row label="Nome Completo">{adolescente.nome_adolescente}</Row>
          <Row label="Data de Nascimento">{fmtDate(adolescente.dt_nasc_adolescente)}</Row>
          <Row label="Sexo">{adolescente.sexo || '—'}</Row>
          <Row label="Nome da Mãe">{adolescente.nome_da_mae || '—'}</Row>
          <Row label="ID Jornada">{adolescente.jornada_id  || '—'}</Row>          
        </div>
      </div>

      {/* Card: Histórico de Movimentações */}
      <div className="card">
        <div className="card-header text-light">
          <h5 className="mb-0">Histórico de Movimentações</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-dark-custom">
              <thead>
                <tr>
                  <th>ID Mov.</th>
                  <th>Situação (atual)</th>
                  <th>Iniciada em</th>
                  <th className="text-end">Ações</th>
                </tr>
              </thead>
              <tbody>
                {movimentacoes.length > 0 ? (
                  movimentacoes.map((mov) => (
                    <tr key={mov.id}>
                      <td>{mov.id}</td>
                      <td>{getSituacaoAtual(mov)}</td>
                      <td>{mov.created_at_formatada || '—'}</td>
                      <td className="text-end">
                        <Link
                          to="/painel/dashboard"
                          className="btn btn-sm btn-outline-primary"
                          title="Ver no Dashboard"
                        >
                          <i className="bi bi-eye" /> Ver no Dashboard
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      Nenhuma movimentação registrada para este adolescente.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdolescenteDetailPage;